import { render, staticRenderFns } from "./customSpecification.vue?vue&type=template&id=09cf5ea0&scoped=true"
import script from "./customSpecification.vue?vue&type=script&lang=js"
export * from "./customSpecification.vue?vue&type=script&lang=js"
import style0 from "./customSpecification.vue?vue&type=style&index=0&id=09cf5ea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cf5ea0",
  null
  
)

export default component.exports